export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13226.f33e9dbf.jpg";